import { render } from "./DueDateCreateOrder.vue?vue&type=template&id=4f900544"
import script from "./DueDateCreateOrder.vue?vue&type=script&lang=js"
export * from "./DueDateCreateOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__